import { useNavigate, useParams } from 'react-router-dom';
import { CurrentRedemPoint, goToLink, loginLogout, useProjectByStorage, WarningDisplay } from '../projectData';
import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import { getRedemCatalog, getUserDashboard } from '../api';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { RedemFilterButton } from './redemptionFiles/multiRangeSlider/redemFilter';
import { useRouteData } from '../RouteDataContext';
import { FullPageLoader } from '../../component/helper';


const RedemptionList = () => {
    const { userData } = useRouteData();
    const navigate = useNavigate();
    const project = useProjectByStorage();
    const [dashboard, setDashboard] = useState(null);

    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm); // For debouncing
    const [hasMore, setHasMore] = useState(true);
    const { cid, category } = useParams()

    const [redemFilters, setRedemFilters] = useState({
        minPoints: 1,
        maxPoints: 3000000,
        category: category ?? "",
        sortOrder: "",
        cid: cid ?? '',
        sortByOffer: 'on_offer'

    })
    // Debounce effect to delay the search query
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
            setPage(1);
            setHasMore(true);
        }, 500);

        return () => clearTimeout(handler);
    }, [searchTerm]);


    useEffect(() => {
        if (userData && project) {
            getUserDashboard({ id: userData?.user?.iirpl_sap_code, project_key: project?.pkey })
                .then((d) => setDashboard(d?.data)).catch((error) => loginLogout(error.response))
        }
    }, [userData, project])

    useEffect(() => {
        setRedemFilters(prevState => ({
            ...prevState,
            page: 1,      // Spread previous state to keep other properties unchanged
            cid: cid    // Update the minPoints value
        }));
    }, [cid])

    const { isLoading, isFetching } = useQuery(
        ['items', page, debouncedSearchTerm, project, cid, redemFilters],
        () => getRedemCatalog({
            page, searchTerm: debouncedSearchTerm, project_key: project?.pkey,
            minPoints: redemFilters.minPoints, maxPoints: redemFilters.maxPoints,
            category: redemFilters.category, sortOrder: redemFilters.sortOrder,
            cid: redemFilters.cid ?? '',
            sortByOffer: redemFilters.sortByOffer
        }),
        {
            keepPreviousData: true,
            onSuccess: (newData) => {
                setItems((prevItems) => (page === 1 ? newData : [...(prevItems || []), ...newData]));
                // setShowNotFound(true)
                if (newData.length === 0) setHasMore(false);
            },
        }
    );

    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight || isFetching || !hasMore) {
            return;
        }
        //setPage((prevPage) => prevPage + 1);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isFetching, hasMore]);
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };
    // const withSpecialOrOfferPoints = data.filter(
    //     gift => gift.gift_offer_point !== null || gift.special_point !== null
    //   );

    //   // Remaining products
    //   const otherProducts = data.filter(
    //     gift => gift.gift_offer_point === null && gift.special_point === null
    //   );
    return (
        <div className='container pt-5 bg-white'>
            <CurrentRedemPoint dashboard={dashboard} />
            <div className="mb-4 ">

                <div className='d-flex  gap-2'>
                    <div className="mt-4 mb-4 rounded border border-dark p-1" style={{ backgroundColor: "#FAFAFA", width: "90%" }}>
                        <div className='d-flex align-items-center'>
                            <i className="bi bi-search text-dark fs-1 p-3"></i>
                            <input
                                type="text"
                                placeholder="Search"
                                className='border-0 w-100 p-3 fs-4 focus-input'
                                value={searchTerm}
                                onChange={handleSearch}
                            //style={{ backgroundColor: "#FAFAFA" }}
                            />
                        </div>
                    </div>
                    <RedemFilterButton setRedemFilters={setRedemFilters} redemFilters={redemFilters} />
                </div>
                <div className="row  mt-4">
                    {Array.isArray(items) && items.length > 0 ? (items.map((item, index) => (
                        <div key={index} onClick={() => goToLink(navigate, `/customer/redem-detail/${item.gifts_id}`, { itemValue: item, dashboard: dashboard })}
                            className={`mb-4 ${item?.gift_offer_point ? 'col-12 col-md-6' : 'col col-md-3 col-6'}`}>
                            {item?.gift_offer_point ? <div className="card h-100 d-flex flex-row rounded border border-secondary ">
                                <div style={{ borderRadius: '0px 5px 0px 14px' }} className="offer-label position-absolute fw-semibolder fs-8 top-0 end-0  px-2 bg-success text-white ">
                                    On Offer
                                </div>
                                <div className="card-body d-flex flex-row p-2 py-4">
                                    <img
                                        className="card-img-top bg-light"
                                        src={item.medium_image_url ? item.medium_image_url : toAbsoluteUrl('/media/logos/blank-big.jpg')}
                                        alt={item?.gift_short_name}
                                        style={{ width: '125px', minWidth: "125px" }}

                                    />
                                    <div className="d-flex flex-column px-4 w-100">
                                        <div className="card-text  fs-6 ">
                                            {item?.gift_short_name}
                                        </div>
                                        <div className=" fw-semibold fs-6 mb-4">
                                            <div className={item?.gift_offer_point ? 'text-muted text-decoration-line-through' : ''}> <i className="bi bi-star me-2"></i>{item?.gift_point} Pts</div>
                                            {item?.gift_offer_point &&
                                                <div> <span className='fw-semibold' style={{ color: `#FF9900` }}>Offer :</span> {item?.gift_offer_point} Pts</div>
                                            }
                                        </div>

                                        <button className="btn btn-primary btn-sm w-100 mt-auto ">
                                            Redeem <i className="bi bi-chevron-right ms-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                                : <div className="card h-100 d-flex rounded border border-secondary">
                                    <div className="card-body d-flex flex-column p-4">
                                        <img
                                            className="card-img-top bg-light mb-3"
                                            src={item.medium_image_url ? item.medium_image_url : toAbsoluteUrl('/media/logos/blank-big.jpg')}
                                            alt={item?.gift_short_name}
                                            style={{ width: '100%' }}
                                        />
                                        <div className="border rounded-bottom text-center p-2 fw-semibold fs-6">
                                            <div className={item?.gift_offer_point ? 'text-muted text-decoration-line-through' : ''}> <i className="bi bi-star me-2"></i>{item?.gift_point} Pts</div>
                                            {item?.gift_offer_point &&
                                                <div> <span className='fw-semibold' style={{ color: `#FF9900` }}>Offer :</span> {item?.gift_offer_point} Pts</div>
                                            }
                                        </div>
                                        <div className="card-text m-2 fs-6 text-center flex-grow-1">
                                            {item?.gift_short_name}
                                        </div>
                                        <button className="btn btn-light-dark btn-sm w-100 mt-auto">
                                            Redeem <i className="bi bi-chevron-right ms-2"></i>
                                        </button>

                                    </div>
                                </div>
                            }
                        </div>
                    ))) : <>
                        {isLoading && <FullPageLoader />}
                        {!isLoading && !hasMore && <WarningDisplay message={'Not Found'} />}
                        {!isLoading && hasMore && <WarningDisplay message={'No more items to load'} />}</>

                    }
                </div>
            </div>

        </div >
    )
}

export default RedemptionList